module.exports = __webpack_public_path__ + "img/img_82837_0_57.a3e32114.png";